import OptionChooser from '../components/OptionChooser';

const OPTIONS = [
  {
    key: 'yard',
    path: '/jobs',
    icon: 'ti-list',
    title: 'Yard',
    subtitle: 'View and manage all yard job entries.',
  },
  {
    key: 'walkin',
    path: '/walkins',
    icon: 'ti-car',
    title: 'Walk-ins',
    subtitle: 'View and manage walk-in customers.',
  },
];

export default function ViewDailySheetChoice() {
  return (
    <OptionChooser
      title="View Daily Sheet"
      prompt="What would you like to view?"
      options={OPTIONS}
    />
  );
}
